import React from 'react';
import PropTypes from 'prop-types';

import {
  TextInput,
} from '../../../fragments/forms';


export default class RefYear extends React.Component {

  static propTypes = {
    reference: PropTypes.object.isRequired,
    readOnly: PropTypes.bool.isRequired,
    showError: PropTypes.bool.isRequired,
    onUpdate: PropTypes.func.isRequired,
  };

  handleUpdate(refYear) {
    const {reference} = this.props;
    reference.refYear = refYear || undefined;

    const {onUpdate} = this.props;
    onUpdate(reference);
  }

  get allMessage() {
    const {reference, showError} = this.props;

    return reference.messages('refYear', showError);
  }

  render() {
    const {reference, readOnly} = this.props;
    const {allMessage} = this;

    return (
      <TextInput
       name="refYear"
       label="Year"
       readOnly={readOnly}
       value={reference.refYear}
       onChange={
         this.handleUpdate.bind(this)}
       messages={allMessage}
      />
    );
  }
}



// WEBPACK FOOTER //
// ./src/views/wizard/reference/reference-edit/refyear.js